<template>
  <Accordion title="Dados da Movimentação">
    <div class="grid grid-cols-4 gap-5">
      <InputNumber v-if="localValue.id" label="Código" placeholder="Insira Código" v-model="localValue.id" :disabled="localValue.id" />
      <Select :items="filteredTypes" v-model="localValue.type" label="Tipo" required :error="localErrors.type" :disabled="localValue.id" />

      <InputZoom
        required
        clearable
        :disabled="localValue.id"
        label="Local Origem"
        v-model="localValue.idOriginWarehouse"
        :error="localErrors.idOriginWarehouse"
        database="warehouse"
        item-value="id"
        item-text="name"
        v-model:complete-object="completeObject"
        placeholder="Selecione o depósito" />

      <InputZoom
        clearable
        required
        :disabled="localValue.id || !localValue.idOriginWarehouse"
        v-model="localValue.idDestinationWarehouse"
        label="Local Destino"
        :error="localErrors.idDestinationWarehouse || localErrors.sameWarehouse"
        :filter="computedItemsFilters"
        database="warehouse"
        item-text="name"
        item-value="id"
        placeholder="Selecione o depósito" />

      <InputDateTime v-model="localValue.date" disabled label="Data" required :error="localErrors.date" placeholder="Selecione a data" />

      <InputZoom
        v-model="localValue.idUser"
        clearable
        :disabled="localValue.id"
        label="Responsável"
        :error="localErrors.idUser"
        database="user"
        item-text="name"
        item-value="id"
        required
        placeholder="Selecione o responsável" />
      <TextArea class="col-span-4" v-model="localValue.description" label="Descrição" placeholder="Insira uma descrição" :error="localErrors.description" />
    </div>
  </Accordion>
</template>

<script setup>
import { computed, reactive, ref, watch, onMounted } from 'vue'
import { useFormat } from '@/composables/useFormat'
import { useStore } from 'vuex'

const store = useStore()
const user = computed(() => store.state.user)

const { formatDatetimeToTimezone } = useFormat()

const type = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
]

const props = defineProps({
  modelValue: Object,
  error: Object,
})

const emits = defineEmits(['update:modelValue'])

import moment from 'moment'

const localValue = reactive(props.modelValue)
const localErrors = ref(props.error)
const completeObject = ref(null)

// Módulo para Corrigir tipos
const allTypes = [
  { label: 'Fornecimento', value: 'outgoing' },
  { label: 'Transferência', value: 'transfer' },
  { label: 'Devolução', value: 'devolution' },
  { label: 'Devolução ao Fornecedor', value: 'supplierDevolution' },
  { label: 'Baixa', value: 'downward' },
]

const allowedTypesByWarehouse = {
  team: ['devolution', 'transfer', 'downward'],
  physic: ['outgoing', 'devolution', 'supplierDevolution', 'transfer'],
  vehicles: ['devolution', 'transfer', 'downward'],
}

const filteredTypes = computed(() => {
  if (!completeObject.value || !completeObject.value.type) {
    return allTypes
  }

  const warehouseType = completeObject.value.type
  const allowedValues = allowedTypesByWarehouse[warehouseType] || []

  return allTypes.filter((type) => allowedValues.includes(type.value))
})

watch(completeObject, (newWarehouse) => {
  if (newWarehouse && newWarehouse.type && localValue.type) {
    const allowedValues = allowedTypesByWarehouse[newWarehouse.type] || []
    if (!allowedValues.includes(localValue.type)) {
      localValue.type = null
    }
  }
})
// Computeds

const computedItemsFilters = computed(() => {
  if (completeObject.value) {
    return [
      { column: 'type', operator: '=', value: completeObject.value.type },
      { column: 'id', operator: '!=', value: completeObject.value.id },
    ]
  }
  return []
})

onMounted(() => {
  // localValue.date = moment()
  localValue.idUser = user.value.id
})

//  Watchers
watch(
  () => props.modelValue,
  (newValue) => {
    localValue.value = newValue
  },
)

watch(
  () => props.error,
  (newValue) => {
    localErrors.value = newValue
  },
)

// watch(
//   () => localValue.idOriginWarehouse,
//   () => {
//     localValue.idDestinationWarehouse = null
//   },
//   { immediate: true }
// )

watch(localValue, (newValue) => {
  emits('update:modelValue', newValue)
})
</script>
